function closeModalvideo() {
    $(".bg-modal-video, .modal-video").fadeOut();
    setTimeout(() => {
        $(".modal-video .videoWrapper").html("");
    }, "500");
}
$(document).ready(function () {
    $('.open-modal-video-js').click((e) => {
        e.preventDefault();
        $(".modal-video, .bg-modal-video").fadeIn();
        iframe = $(e.currentTarget).attr("data-iframe");
        videoOrientation = $(e.currentTarget).attr("data-iframe-orientation");
        $(".modal-video .videoWrapper").html(`<iframe allow=autoplay width='100%' height='415' class='video-orientation-${videoOrientation}' src='https://www.youtube.com/embed/${iframe}?autoplay=1&enable_js=1' frameborder='0' allowfullscreen></iframe>`);
    });
    $('.close-modal-video, .bg-modal-video').click(() => {
        closeModalvideo();
    });
    $(document).keyup((event) => {
        if (event.which == '27') {
            closeModalvideo();
        }
    });
});